{
  "de": {
    "integration": {
      "actions": {
        "goTo": "Zu {name} gehen"
      },
      "labels": {
        "apiTokensUsedByYou": "API-Tokens",
        "create_failed": "Erstellung fehlgeschlagen",
        "crm_id": "{integration_oid_type}-ID in {integration_name}: {integration_oid}",
        "description": "Beschreibung",
        "error": "Fehler",
        "integration": "Integration",
        "integrationOID": "Integrations-ID",
        "last_sync_with": "Letzte Synchronisierung mit {integration_name} ({last_sync_at})",
        "status": "Status",
        "synced_at": "Letzte Synchronisierung: ",
        "title": "Von Ziggu verwaltete Integrationen",
        "update_failed": "Aktualisierung fehlgeschlagen"
      },
      "record_actions": {
        "delete": "Damit {record_type} dauerhaft aus Ziggu gelöscht wird (und nicht wieder erscheint), muss {record_type} <strong>zuerst in {integration_name} gelöscht werden</strong>."
      },
      "toasts": {
        "update": "Integration aktualisiert"
      }
    }
  }
}
